import { parseUtcMs } from "@/shared/utils/datetime/public";

const EXPIRY_MARGIN_MS = 60_000;

// 시계 차이를 고려해 60초 여유를 둔다. 받을 때 이미 만료 구간이면 같은 응답을 다시 받아도
// 오류가 반복될 수 있다. 그래서 받은 뒤에 만료 경계를 지난 URL 만 갱신한다.
export function hasVideoUrlExpiredSinceReceipt(
  expiresAt: string | null,
  receivedAtMs: number,
  nowMs: number,
): boolean {
  const expiresAtMs = parseUtcMs(expiresAt);
  if (expiresAtMs === null) return false;
  const refreshAfterMs = expiresAtMs - EXPIRY_MARGIN_MS;
  return receivedAtMs < refreshAfterMs && nowMs >= refreshAfterMs;
}
